import axios from 'axios'

import { getBaseHref } from '../shared/env'

/* Newsletter */
/* For now, simulates submitting, but does nothing. */
function initNewsletterSubscriptionForm () {

    const newsletterEl = document.querySelector('.partials-main-footer .newsletter-wrapper')
    if (!newsletterEl) return;

    const formEl = newsletterEl.querySelector('form')
    const inputEl = newsletterEl.querySelector('input[type="text"]')
    const messageEl = newsletterEl.querySelector('.message')

    /* Dataset */
    const loadingClass = newsletterEl.dataset.loadingClass
    const sentClass = newsletterEl.dataset.sentClass
    const successMessage = newsletterEl.dataset.successMessage
    const errorMessage = newsletterEl.dataset.errorMessage
    const errorInvalidEmailMessage = newsletterEl.dataset.errorInvalidEmailMessage
    const messageErrorClass = messageEl.dataset.errorClass

    const doError = (message) => {
        if (message === undefined)
        {
            message = errorMessage
        }
        messageEl.classList.add(messageErrorClass)
        messageEl.innerHTML = message
        newsletterEl.classList.remove(loadingClass)
    }

    formEl.addEventListener('submit', (event) => {
        event.preventDefault()
        newsletterEl.classList.add(loadingClass)
        messageEl.innerHTML = ''
        messageEl.classList.remove(messageErrorClass);
        axios.post(getBaseHref() + 'ajax/newsletter-subscription',
            axios.toFormData({
                email: inputEl.value,
            }))
            .then ((ajaxResponse) => {
                if (ajaxResponse.data.message === 'sent')
                {
                    newsletterEl.classList.remove(loadingClass)
                    newsletterEl.classList.add(sentClass)
                    messageEl.innerHTML = successMessage.replace('{email}', inputEl.value)
                    inputEl.value = '';
                }
                else
                {
                    doError()
                }
            })
            .catch((error) => {
                if (error.response && error.response.data.message === 'invalid-email')
                {
                    doError(errorInvalidEmailMessage)
                }
                else
                {
                    doError()
                }
            })
    })

}

document.addEventListener('DOMContentLoaded', () => {
    initNewsletterSubscriptionForm()
})
